// Actions para el Administrador Central de Cálculos (ACC)

// Action para inicializar la página (carga todos los datos)
export const startAccShowcase = () => ({
  type: "START_ACC_SHOWCASE",
});

// Actions para parámetros ACC
export const startGetAccParameters = () => ({
  type: "START_GET_ACC_PARAMETERS",
});

export const getAccParametersSuccess = (data) => ({
  type: "GET_ACC_PARAMETERS_SUCCESS",
  data,
});

export const getAccParametersFail = (error) => ({
  type: "GET_ACC_PARAMETERS_FAIL",
  error,
});

// Actions para tasas de usura
export const startGetUsuraRates = (filters = {}) => ({
  type: "START_GET_USURA_RATES",
  filters,
});

export const getUsuraRatesSuccess = (data) => ({
  type: "GET_USURA_RATES_SUCCESS",
  data,
});

export const getUsuraRatesFail = (error) => ({
  type: "GET_USURA_RATES_FAIL",
  error,
});

// Actions para crear/actualizar tasas de usura
export const startCreateOrUpdateUsuraRate = (data) => ({
  type: "START_CREATE_OR_UPDATE_USURA_RATE",
  data,
});

export const createOrUpdateUsuraRateSuccess = (data, operationType) => ({
  type: "CREATE_OR_UPDATE_USURA_RATE_SUCCESS",
  data,
  operationType, // 'create' o 'update'
});

export const createOrUpdateUsuraRateFail = (error) => ({
  type: "CREATE_OR_UPDATE_USURA_RATE_FAIL",
  error,
});

// Actions para loading states
export const setAccLoading = (isLoading) => ({
  type: "SET_ACC_LOADING",
  isLoading,
});

// Actions para limpiar errores
export const clearAccError = () => ({
  type: "CLEAR_ACC_ERROR",
});
